module.exports = __webpack_public_path__ + "img/header.4cc1658f.svg";